import React from 'react'

import './CreateWallet.css'
import TitleHolder from '../shared/TitleHolder/TitleHolder'
import QbHeading from '../shared/QbHeading/QbHeading'
import QbInput from '../shared/QbInput/QbInput'
import QbLink from '../shared/QbLink/QbLink'
import QbButton from '../shared/QbButton/QbButton'
import { RESTORE_WALLET_NAV } from '../../constants/navigation'
import { TermsBox } from '../Terms/Terms'

const CreateWallet = ({
  t,
  createProfile,
  onPasswordChange,
  onRepeatPasswordChange,
  onCreateWalletClick,
  onCheckboxClick,
  errorMessages,
  checkboxError,
  checkboxSelected
}) => (
  <div className="main-content-container">
    <TitleHolder title={t('wallet.create.title')} />
    <div className="main-content-body">
      <QbHeading title={t('wallet.create.headline')} text={t('wallet.create.message')} />
      <div className="create-wallet-content">

        <QbInput
          type="password"
          value={createProfile.password}
          title={t('wallet.create.type-password-label')}
          errorMessage={t(errorMessages.password)}
          onChange={onPasswordChange}
        />

        <QbInput
          type="password"
          value={createProfile.repeatPassword}
          title={t('wallet.create.retype-password-label')}
          errorMessage={t(errorMessages.repeatPassword)}
          onChange={onRepeatPasswordChange}
        />

        <TermsBox
          checkboxSelected={checkboxSelected}
          onCheckboxClick={onCheckboxClick}
          checkboxError={checkboxError}
        />        

        <div className="main-content-footer">
          <QbLink name={t('nav.restore-wallet')} to={RESTORE_WALLET_NAV} />
          <QbButton name="Create Wallet" onClick={onCreateWalletClick} />
        </div>

      </div>
    </div>
  </div>
)

export default CreateWallet



// WEBPACK FOOTER //
// ./src/components/CreateWallet/CreateWallet.js